import { render } from "./ShopPerformance.vue?vue&type=template&id=003977b3"
import script from "./ShopPerformance.vue?vue&type=script&lang=js"
export * from "./ShopPerformance.vue?vue&type=script&lang=js"

import "./ShopPerformance.vue?vue&type=style&index=0&id=003977b3&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__